module.exports = __webpack_public_path__ + "static/media/quote-rtl.810f5165.svg";